angular.module('admin')
.controller('AdminPracticeController', ['$scope', '$http', '$uibModal', '$location', 'ModalHandler', 'Notification', 'Address', 'Practice', 'Subscription', 'SubscriptionHelper', 'UpgradeModal', 'FREE_TRIAL_PERIOD', 'UnsavedChanges', 'Logger', 'PracticeEditMode', 'Procedure', 'clipboard', 'UploadService', 'User', 'BrandingRequest', 'API_ENDPOINT', 'ConfirmDialog', '$filter',
    function ($scope, $http, $uibModal, $location, ModalHandler, Notification, Address, Practice, Subscription, SubscriptionHelper, UpgradeModal, FREE_TRIAL_PERIOD, UnsavedChanges, Logger, PracticeEditMode, Procedure, clipboard, UploadService, User, BrandingRequest, API_ENDPOINT, ConfirmDialog, $filter) {

        $scope.showWarning = false;
        $scope.linkHelpExpanded = false;
        $scope.brandingHelpExpanded = false;
        $scope.currentPracticeType = {};
        $scope.practiceTypes = Procedure.practiceTypes({'include_procedures': false});
        $scope.practice = Practice.get({practiceId: $scope.$parent.auth.practice_id}, function (practice) {
            $scope.currentPracticeType = practice.practice_type;
        });

        // Subscription management
        $scope.subscriptionStatus = null;
        $scope.subscriptionLoading = true;
        $scope.subscriptionError = null;

        // Check for subscription query params (redirect from Stripe)
        var subscriptionParam = $location.search().subscription;
        if (subscriptionParam === 'success') {
            Notification.success('Your subscription has been activated! Premium features are now available.');
            $location.search('subscription', null);
        } else if (subscriptionParam === 'cancelled') {
            Notification.info('Subscription upgrade was cancelled.');
            $location.search('subscription', null);
        }

        // Deep link (DCL-443): #!/admin/practice?upgrade=true opens the upgrade dialog,
        // e.g. from upgrade-prompt emails. Consumed once the subscription status loads;
        // cleared right away so a refresh or Stripe round-trip doesn't reopen it. An
        // optional ?src names who linked here, for DCL-532; links already sent have none.
        var openUpgradeOnLoad = !!$location.search().upgrade;
        var upgradeLinkSource = $location.search().src || 'deep_link';
        if (openUpgradeOnLoad) {
            $location.search('upgrade', null).search('src', null).replace();
        }

        // Load subscription status
        $scope.loadSubscriptionStatus = function() {
            $scope.subscriptionLoading = true;
            $scope.subscriptionError = null;
            Subscription.getStatus({}, function(status) {
                $scope.subscriptionStatus = status;
                $scope.subscriptionLoading = false;
                if (openUpgradeOnLoad) {
                    openUpgradeOnLoad = false;
                    // DCL-508: an active complimentary trial can (and should be able
                    // to) convert to paid, so the deep link works for it too. Only a
                    // paying Premium practice ignores the link.
                    if (!status.premium_access || (status.subscription && status.subscription.complimentary)) {
                        $scope.openUpgradeModal(upgradeLinkSource);
                    }
                }
            }, function(error) {
                $scope.subscriptionError = 'Unable to load subscription status';
                $scope.subscriptionLoading = false;
                Logger.log('Error loading subscription status: ' + JSON.stringify(error));
            });
        };

        $scope.loadSubscriptionStatus();

        // Get subscription status description
        $scope.getSubscriptionStatusText = function() {
            if (!$scope.subscriptionStatus) return '';
            return SubscriptionHelper.getStatusDescription($scope.subscriptionStatus);
        };

        // Label for the main upgrade button — trial-vs-upgrade wording is
        // decided in SubscriptionHelper (DCL-561).
        $scope.upgradeButtonText = function() {
            if (!$scope.subscriptionStatus) return '';
            return SubscriptionHelper.getUpgradeButtonText($scope.subscriptionStatus);
        };

        // Format price for display
        $scope.formatPrice = function(cents) {
            return SubscriptionHelper.formatPrice(cents);
        };

        // Format interval for display
        $scope.formatInterval = function(interval) {
            return SubscriptionHelper.formatInterval(interval);
        };

        // Open upgrade modal
        $scope.openUpgradeModal = function(source) {
            UpgradeModal.open({status: $scope.subscriptionStatus, source: source || 'account_settings'});
        };

        // Open billing portal
        $scope.openBillingPortal = function() {
            SubscriptionHelper.redirectToBillingPortal(Subscription, function(error) {
                if (error && error.data && error.data.customer_deleted) {
                    Notification.warning('Your billing account no longer exists. Please upgrade again to create a new subscription.');
                    $scope.loadSubscriptionStatus();
                } else {
                    Notification.error('Unable to access billing portal. Please try again.');
                }
                Logger.log('Billing portal error: ' + JSON.stringify(error));
            });
        };

        // Confirm and process billing interval change
        $scope.confirmIntervalChange = function(newInterval) {
            // Annual billing is gated (DCL-379). Guard the switch-to-annual path so a stale
            // view or crafted call can't initiate an annual switch (and surface annual copy)
            // while it's disabled. The backend also rejects this.
            if (newInterval === 'year' && !($scope.subscriptionStatus && $scope.subscriptionStatus.annual_billing_enabled)) {
                return;
            }
            var isUpgrade = newInterval === 'year';

            // The quoted amount comes from /subscriptions/prices, the one place the flat
            // Premium price is published to the SPA (DCL-557). prices.annual is present
            // whenever the annual switch is offered (same flag on both sides).
            Subscription.getPrices({}, function(prices) {
                var target = isUpgrade ? prices.annual : prices.monthly;
                var priceDisplay = SubscriptionHelper.formatPrice(target.amount) + (isUpgrade ? '/year' : '/month');
                var message = isUpgrade ?
                    'Switch to annual billing? You\'ll receive a prorated credit for your current month and be charged ' + priceDisplay + ' starting now.' :
                    'Switch to monthly billing? The change will take effect at your next renewal date. You\'ll be billed ' + priceDisplay + ' after your current annual period ends.';

                ConfirmDialog.open({
                    title: isUpgrade ? 'Switch to Annual Billing' : 'Switch to Monthly Billing',
                    message: message,
                    confirmText: 'Confirm',
                    cancelText: 'Cancel'
                }).then(function(confirmed) {
                    if (!confirmed) {
                        return;
                    }
                    Subscription.changeInterval({ interval: newInterval }, function(response) {
                        Notification.success(response.message);
                        $scope.loadSubscriptionStatus();
                    }, function(error) {
                        Notification.error('Unable to change billing interval. Please try again.');
                        Logger.log('Interval change error: ' + JSON.stringify(error));
                    });
                });
            }, function(error) {
                Notification.error('Unable to load pricing information. Please try again.');
                Logger.log('Prices error: ' + JSON.stringify(error));
            });
        };

        var updateWarningForCurrentType = function() {
            if ($scope.practice.practice_type && $scope.practice.practice_type.code === 'multi_specialty') {
                $scope.showWarning = 'first_warning';
            } else {
                $scope.showWarning = 'second_warning';
            }
            $scope.$applyAsync();
        };

        PracticeEditMode.setOnEditCallback(updateWarningForCurrentType);
        PracticeEditMode.setOnSaveCallback(function() {
            $scope.showWarning = false;
            $scope.$applyAsync();
        });

        var updatePractice = function (form) {
            Practice.update({practiceId: $scope.practice.id},
                {
                    practice: {
                        name: $scope.practice.name,
                        practice_type_id: $scope.practice.practice_type.id,
                        addresses_attributes: $scope.practice.addresses
                    }
                },
                function (success) {
                    var newAddressNotification = '';
                    $scope.practice.addresses.forEach(function(address){
                        if(typeof(address.new) !== 'undefined' && address.new) {
                            newAddressNotification = ' All users in this practice are now associated with new location. Please edit user settings to change location assignments if necessary.';
                        }
                    });
                    form.$setPristine();
                    $scope.currentPracticeType = $scope.practice.practice_type;
                    $scope.showWarning = false;
                    $scope.practice.addresses = success.addresses;
                    // no UnsavedChanges operations here, we stay on page, callback stays the same, form is now pristine
                    // note: the other tab form might not be pristine here. See #72581022
                    Notification.success('Account was updated successfully!' + newAddressNotification);
                },
                function (failure) {
                    Notification.error('An error occurred during account update...');
                });
        };

        $scope.changePracticeType = function(newValue){
            if (newValue.code === 'multi_specialty') {
                $scope.showWarning = 'first_warning';
            } else {
                $scope.showWarning = 'second_warning';
            }
        };

        $scope.savePractice = function (form) {
            if (!form.$dirty || form.$invalid) return;
            updatePractice(form);
        };

        // DCL-558: Basic practices are capped at one location. `plan_limits`
        // arrives on the practice payload; a null limit means Premium, which
        // only has the long-standing 20-location UI maximum. Unsaved rows are in
        // practice.addresses, so the rule holds before the form is saved. The
        // backend enforces the same cap (402 premium_required) regardless.
        var MAX_LOCATIONS = 20;

        function basicLocationLimit() {
            var limits = $scope.practice && $scope.practice.plan_limits;
            return (limits && limits.locations && limits.locations.limit) || null;
        }

        $scope.locationLimit = function () {
            return basicLocationLimit() || MAX_LOCATIONS;
        };

        $scope.locationLimitReached = function () {
            var limit = basicLocationLimit();
            return !!(limit && $scope.practice.addresses && $scope.practice.addresses.length >= limit);
        };

        $scope.canAddAddress = function () {
            return !!($scope.practice && $scope.practice.addresses && $scope.practice.addresses.length < $scope.locationLimit());
        };

        $scope.addAddress = function () {
            if ($scope.canAddAddress()) {
                $scope.practice.addresses.push({new: true});
            }
        };

        $scope.copyToClipboard = function(value, message){
            clipboard.copyText(value);
            Notification.info(message + ' ' + value + ' was copied to clipboard');
        };

        // DCL-638: the delete runs now, not when the section is saved, and an
        // unsaved row has nothing to lose, so it goes without asking.
        $scope.confirmRemoveAddress = function (address) {
            if (!address.id) {
                $scope.removeAddress(address);
                return;
            }

            ConfirmDialog.open({
                title: 'Delete this location?',
                message: ($filter('fullAddress')(address) || 'This location') + ' will be removed from your practice right away.',
                warning: $scope.locationLimitReached() ? "You won't be able to add it back on the Basic plan." : null,
                confirmText: 'Delete location'
            }).then(function (confirmed) {
                if (confirmed) {
                    $scope.removeAddress(address);
                }
            });
        };

        $scope.removeAddress = function (address) {
            function removeAddressFromList(addressToRemove) {
                // A save can replace the list with new objects while a delete is pending,
                // so a saved location is matched by id. A miss must not reach splice(-1).
                var index = $scope.practice.addresses.findIndex(function (address) {
                    return address === addressToRemove || (addressToRemove.id && address.id === addressToRemove.id);
                });
                if (index !== -1) {
                    $scope.practice.addresses.splice(index, 1);
                }
            }

            if (address.id) {
                Address.remove({id: address.id}, function () {
                    removeAddressFromList(address);
                }, function (failure) {
                    // A 404 means it's already gone, so the row should go too.
                    if (failure.status === 404) {
                        removeAddressFromList(address);
                        return;
                    }
                    Notification.error((failure.data && failure.data.message) ||
                        'An error occurred while deleting the location...');
                });
            } else {
                removeAddressFromList(address);
            }
        };

        // TODO: Doesn't seem to notice practice being actively edited - allows to switch to any other tab or page.
        UnsavedChanges.setCbHaveUnsavedChanges(function () {
            return !!$scope.practiceForm && $scope.practiceForm.$dirty;
        });

        // --- Custom Branding Request ---
        $scope.brandingRequest = {
            contact_email: $scope.$parent.auth.email || '',
            first_name: '',
            background_color: '#ffffff'
        };
        $scope.pendingBrandingRequest = null;
        $scope.brandingRequestSubmitting = false;

        // Load existing pending branding request
        BrandingRequest.pending(function(result) {
            if (result && result.id) {
                $scope.pendingBrandingRequest = result;
            }
        });

        // Pre-fill first_name from current user
        User.get({ id: $scope.$parent.auth.id }, function(user) {
            if (user.first_name && !$scope.brandingRequest.first_name) {
                $scope.brandingRequest.first_name = user.first_name;
            }
        });

        // Set up file uploader for branding logo
        $scope.brandingLogoUploader = UploadService.createUploader({
            scope: $scope,
            url: API_ENDPOINT + '/branding_requests',
            alias: 'logo',
            formData: [],
            eachFileSizeLimit: 5 * 1024 * 1024,
            immediateUpload: false,
            messages: {
                eachTooLarge: 'Logo file must be smaller than 5 MB.',
                addFail: 'Could not add this file. Please use a PNG, JPEG, WebP, or SVG image.'
            },
            onSuccessItem: function(item, response) {
                $scope.pendingBrandingRequest = response;
                $scope.brandingRequestSubmitting = false;
                Notification.success('Custom branding request submitted successfully!');
                $scope.brandingLogoUploader.clearQueue();
                resetBrandingFormControls();
            },
            onErrorItem: function(item, response, status) {
                $scope.brandingRequestSubmitting = false;
                if (status === 403) {
                    Notification.error('Only practice administrators can request custom branding.');
                } else {
                    var msg = response && response.logo ? response.logo[0] : 'An error occurred. Please try again.';
                    Notification.error(msg);
                }
            }
        });

        // Filter to only accept image files
        $scope.brandingLogoUploader.filters.push({
            name: 'imageFilter',
            fn: function(item) {
                var type = item.type || '';
                if (!type.match(/^image\/(png|jpeg|webp|svg\+xml)$/)) {
                    Notification.error('Please upload a PNG, JPEG, WebP, or SVG image.');
                    return false;
                }
                return true;
            }
        });

        $scope.submitBrandingRequest = function() {
            if (!$scope.brandingLogoUploader.queue.length) {
                Notification.error('Please select a logo image.');
                return;
            }
            if (!$scope.brandingRequest.contact_email || !$scope.brandingRequest.first_name || !$scope.brandingRequest.background_color) {
                Notification.error('Please fill in all fields.');
                return;
            }

            $scope.brandingRequestSubmitting = true;

            var item = $scope.brandingLogoUploader.queue[0];
            item.formData = [{
                contact_email: $scope.brandingRequest.contact_email,
                first_name: $scope.brandingRequest.first_name,
                background_color: $scope.brandingRequest.background_color
            }];
            item.upload();
        };

        // DCL-366: after a successful submit, clearQueue() empties the uploader
        // but the native file input still displays the chosen file name — clear
        // it and the color controls so the form doesn't look half-filled.
        function resetBrandingFormControls() {
            var input = document.querySelector('input[uploader="brandingLogoUploader"]');
            if (input) {
                input.value = '';
            }
            $scope.brandingRequest.background_color = '#ffffff';
        }

        function openBrandingPreviewModal(logoDataUrl, backgroundColor) {
            ModalHandler.dismissIfOpen();
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/branding_preview_modal.html',
                controller: 'BrandingPreviewModalController',
                size: 'lg',
                ariaLabelledBy: 'branding-preview-title',
                resolve: {
                    preview: function() {
                        return {
                            logoDataUrl: logoDataUrl,
                            backgroundColor: backgroundColor
                        };
                    }
                }
            });
            ModalHandler.set(modalInstance);
        }

        // DCL-366: preview the branding in mock web header, email, and PDF
        // contexts. Uses the freshly queued file + chosen color when one is
        // selected; otherwise falls back to the already-submitted pending
        // request (logo fetched from the backend, its stored color).
        $scope.openBrandingPreview = function() {
            var item = $scope.brandingLogoUploader.queue[0];
            if (item && item._file) {
                var reader = new FileReader();
                reader.onload = function(e) {
                    $scope.$apply(function() {
                        openBrandingPreviewModal(e.target.result, $scope.brandingRequest.background_color);
                    });
                };
                reader.onerror = function() {
                    $scope.$apply(function() {
                        Notification.error('Could not read the selected image. Please select the logo file again.');
                    });
                };
                reader.readAsDataURL(item._file);
            } else if ($scope.pendingBrandingRequest) {
                var pending = $scope.pendingBrandingRequest;
                $http.get(API_ENDPOINT + '/branding_requests/' + pending.id + '/logo', { responseType: 'blob' })
                    .then(function(response) {
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            $scope.$apply(function() {
                                openBrandingPreviewModal(e.target.result, pending.background_color);
                            });
                        };
                        reader.readAsDataURL(response.data);
                    }, function() {
                        Notification.error('Could not load the logo from your submitted request. Please try again.');
                    });
            } else {
                Notification.error('Please select a logo image first.');
            }
        };

        $scope.cancelBrandingRequest = function() {
            if (!$scope.pendingBrandingRequest) return;

            BrandingRequest.remove({ id: $scope.pendingBrandingRequest.id }, function() {
                $scope.pendingBrandingRequest = null;
                Notification.success('Branding request cancelled.');
            }, function() {
                Notification.error('Unable to cancel request. Please try again.');
            });
        };

    }]);